module.exports = __webpack_public_path__ + "static/media/templateIcon.ca889d74.svg";